/*
 *   Copyright 2022-2024 SenX S.A.S.
 *
 *   Licensed under the Apache License, Version 2.0 (the "License");
 *   you may not use this file except in compliance with the License.
 *   You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 *   Unless required by applicable law or agreed to in writing, software
 *   distributed under the License is distributed on an "AS IS" BASIS,
 *   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *   See the License for the specific language governing permissions and
 *   limitations under the License.
 */
export class Param {
    constructor() {
        this.scheme = 'WARP10';
        this.datasetNoAlpha = false;
        this.timeZone = 'UTC';
        this.showRangeSelector = false;
        this.showDots = false;
        this.timeUnit = 'us';
        this.hideYAxis = false;
        this.hideXAxis = false;
        this.showLegend = false;
        this.showValues = false;
        this.fullDateDisplay = false;
        this.showControls = false;
        this.expandAnnotation = false;
        this.displayExpander = true;
        this.leftMargin = 0;
        this.showLoader = false;
        this.noDataLabel = 'No data';
        this.poiLine = 'dotted';
        this.dotSize = 5;
        this.strokeWidth = 1;
    }
}
//# sourceMappingURL=param.js.map
